export const STEPS = {
  LEGAL_ENTITY_INFORMATION: 'legalEntityInformation',
  OWNERS_INFORMATION: 'ownersInformation',
  BANKING_INFORMATION: 'bankingInformation',
  SALES_INFORMATION: 'salesInformation',
  APPLICANT_INFORMATION: 'applicantInformation',
  TERMS_AND_AGREEMENT: 'termsAndAgreement'
};
